import { Badge, IconButton } from '@mui/material';

import { Notifications } from '@mui/icons-material';

export default function NotificationButton() {
  return (
    // <Link replace href="/dashboard?notification=true">
    <Badge
      badgeContent={3}
      sx={{
        cursor: 'pointer',
        mr: 3,
        '& .MuiBadge-badge': {
          right: 10.5,
          top: 10.5,
          minWidth: 15,
          width: 15,
          height: 15,
          backgroundColor: '#FF0000',
          color: '#FFFFFF',
        },
      }}
    >
      <IconButton>
        <Notifications />
      </IconButton>
    </Badge>
    // </Link>
  );
}
